@if (!hide) {
  <div id="collapse-action" class="collapse-action" role="button" tabindex="0"
    (click)="toggle()" (keydown.enter)="toggle()" (keydown.space)="toggle()">
    <div class="action">
      @if (isOpen) {
        <img src="assets/images/ic_arrow_closed.svg" class="arror-image" alt="" />
      } @else {
        <img src="assets/images/ic_arrow_opened.svg" class="arror-image" alt="" />
      }
    </div>
    <div class="header">
      <ng-content select="[header]"></ng-content>
    </div>
  </div>
}

<div #collapse="ngbCollapse" [ngbCollapse]="isOpen || hide">
  <ng-content select="[content]"></ng-content>
</div>
